import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  chatSidebarOpen: boolean;
  
  whatSystemDoesExpanded: boolean;
  latestRecommendationExpanded: boolean;
  howUnitsDistributedExpanded: boolean;
  detailedReasoningExpanded: boolean;
  
  hasFileChange: boolean;
  
  darkMode: boolean;
  
  snackbar: {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'warning' | 'info';
  };
}

const initialState: UIState = {
  chatSidebarOpen: false,
  whatSystemDoesExpanded: false, 
  latestRecommendationExpanded: false, 
  howUnitsDistributedExpanded: false,
  detailedReasoningExpanded: false,
  hasFileChange: false,
  darkMode: false,
  snackbar: {
    open: false,
    message: '',
    severity: 'info',
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {

    openChatSidebar(state) {
      state.chatSidebarOpen = true;
    },
    closeChatSidebar(state) {
      state.chatSidebarOpen = false;
    },
    toggleChatSidebar(state) {
      state.chatSidebarOpen = !state.chatSidebarOpen;
    },
    

    toggleWhatSystemDoes(state) {
      state.whatSystemDoesExpanded = !state.whatSystemDoesExpanded;
    },
    toggleLatestRecommendation(state) {
      state.latestRecommendationExpanded = !state.latestRecommendationExpanded;
    },
    toggleHowUnitsDistributed(state) {
      state.howUnitsDistributedExpanded = !state.howUnitsDistributedExpanded;
    },
    toggleDetailedReasoning(state) {
      state.detailedReasoningExpanded = !state.detailedReasoningExpanded;
    },
    

    setWhatSystemDoesExpanded(state, action: PayloadAction<boolean>) {
      state.whatSystemDoesExpanded = action.payload;
    },
    setLatestRecommendationExpanded(state, action: PayloadAction<boolean>) {
      state.latestRecommendationExpanded = action.payload;
    },
    

    setFileChange(state, action: PayloadAction<boolean>) {
      state.hasFileChange = action.payload;
    },
    

    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    },
    setDarkMode(state, action: PayloadAction<boolean>) {
      state.darkMode = action.payload;
    },
    

    showSnackbar(
      state,
      action: PayloadAction<{ message: string; severity?: 'success' | 'error' | 'warning' | 'info' }>
    ) {
      state.snackbar = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideSnackbar(state) {
      state.snackbar.open = false;
    },
  },
});

export const {
  openChatSidebar,
  closeChatSidebar,
  toggleChatSidebar,
  toggleWhatSystemDoes,
  toggleLatestRecommendation,
  toggleHowUnitsDistributed,
  toggleDetailedReasoning,
  setWhatSystemDoesExpanded,
  setLatestRecommendationExpanded,
  setFileChange,
  toggleDarkMode,
  setDarkMode,
  showSnackbar,
  hideSnackbar,
} = uiSlice.actions;

export default uiSlice.reducer;
